import { apiGet, apiPostJson } from './client'

export function ticketPlanQuery(ticketId: number) {
  return {
    queryKey: ['easeedesk', 'ticket', ticketId, 'plan'] as const,
    queryFn: () => apiGet<Record<string, unknown>>(`/api/v2/easeedesk/tickets/${ticketId}/plan`),
  }
}

export function launchPlanStep(ticketId: number, stepId: number, body: Record<string, unknown>) {
  return apiPostJson(`/api/v2/easeedesk/tickets/${ticketId}/plan/steps/${stepId}/launch`, body)
}

export function donePlanStep(ticketId: number, stepId: number, note: string) {
  return apiPostJson(`/api/v2/easeedesk/tickets/${ticketId}/plan/steps/${stepId}/done`, { note })
}

export function skipPlanStep(ticketId: number, stepId: number, reason: string) {
  return apiPostJson(`/api/v2/easeedesk/tickets/${ticketId}/plan/steps/${stepId}/skip`, { reason })
}

export function askAdamPlan(ticketId: number) {
  return apiPostJson(`/api/v2/easeedesk/tickets/${ticketId}/plan/ask-adam`, {})
}

export function deskWaitingQuery(companyId?: number) {
  const q = companyId ? `?company=${companyId}` : ''
  return {
    queryKey: ['autonomy', 'desk', 'waiting', companyId ?? 0] as const,
    queryFn: () => apiGet<Record<string, unknown>>(`/api/v2/autonomy/desk/waiting${q}`),
  }
}
